class FontCell {
    constructor() {
        this.id = 100
        this.name = ""
        this.class = ""
        this.file = ""
        this.isUser = true
    }
}
export default FontCell